export default __webpack_public_path__ + "static/media/headPhoto.1f6a1f6a.png";